export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    checked: {
      // 已选中数据
      type: Array,
      default: () => {
        return [];
      }
    },
    includeId: {
      // 包含，[string] id
      type: Array,
      default: () => []
    },
    excludeId: {
      // 不包含，[string] id
      type: Array,
      default: () => []
    }
  },
  mounted() {
    if (this.isGroup) {
      this.parent.addItem(this);
    }
  },
  methods: {
  
  },
  computed: {
    checkedId() {
      return this.checked.map(item => item.id);
    },
    isGroup() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.name !== "choose-wrapper") {
          parent = parent.$parent;
        } else {
          return true;
        }
      }
      return false;
    },
    parent() {
      let parent = this.$parent;
      let parentName = parent.$options.name;
      while (parentName !== "choose-wrapper") {
        parent = parent.$parent;
        parentName = parent.$options.name;
      }
      return parent;
    }
  }
};
